import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-7 col-12-xs pb-20" }
const _hoisted_3 = { class: "zoom-bg" }
const _hoisted_4 = { class: "d-block zoom-bg__frame" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "col-5 col-12-xs d-flex",
  style: {"flex-direction":"column","justify-content":"space-between"}
}
const _hoisted_7 = { class: "h4m mb-10" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "row"
}
const _hoisted_10 = { class: "col-7 col-12-xs pb-20" }
const _hoisted_11 = { class: "zoom-bg" }
const _hoisted_12 = { class: "d-block zoom-bg__frame" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "zoom-bg__overlay zoom-bg__overlay--full d-flex text-white text-center",
  style: {"justify-content":"center","align-items":"center"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.2 28.2",
  style: {"max-width":"50px","margin":"0 auto"}
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.2 28.2",
  style: {"max-width":"50px","margin":"0 auto"}
}
const _hoisted_19 = {
  class: "col-5 col-12-xs d-flex",
  style: {"flex-direction":"column","justify-content":"space-between"}
}
const _hoisted_20 = { class: "h4m mb-10" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (!_ctx.questionAnswered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.showImg(_ctx.question.image),
                  alt: "",
                  class: "zoom-bg__img"
                }, null, 8 /* PROPS */, _hoisted_5)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, "Question " + _toDisplayString(_ctx.questionNumber) + " / " + _toDisplayString(_ctx.totalQuestions), 1 /* TEXT */),
            _createElementVNode("div", {
              innerHTML: _ctx.question.description
            }, null, 8 /* PROPS */, _hoisted_8),
            _createElementVNode("button", {
              class: "button button--ghost-inversed mb-20",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chooseAnswer(1)))
            }, _toDisplayString(_ctx.question.answerA), 1 /* TEXT */),
            _createElementVNode("button", {
              class: "button button--ghost-inversed mb-20",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.chooseAnswer(2)))
            }, _toDisplayString(_ctx.question.answerB), 1 /* TEXT */),
            _createElementVNode("button", {
              class: "button button--ghost-inversed mb-0",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.chooseAnswer(3)))
            }, _toDisplayString(_ctx.question.answerC), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.questionAnswered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: _ctx.showImg(_ctx.question.image),
                  alt: "",
                  class: "zoom-bg__img"
                }, null, 8 /* PROPS */, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.questionAnswered && _ctx.questionAnsweredCorrectly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("circle", {
                          fill: "#7ed321",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.07",
                          cx: "14.1",
                          cy: "14.1",
                          r: "13.06"
                        }, null, -1 /* CACHED */),
                        _createElementVNode("polyline", {
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.07",
                          points: "20.1 10.04 12.02 18.12 8.95 15.05"
                        }, null, -1 /* CACHED */)
                      ]))])),
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mt-20" }, "Well done!", -1 /* CACHED */)),
                      _createElementVNode("p", null, "The answer is: " + _toDisplayString(_ctx.correctAnswerText) + ".", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.questionAnswered && !_ctx.questionAnsweredCorrectly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_18, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("circle", {
                          stroke: "currentColor",
                          fill: "#eb5346",
                          "stroke-width": "2.07",
                          "stroke-miterlimit": "10",
                          cx: "14.1",
                          cy: "14.1",
                          r: "13.06"
                        }, null, -1 /* CACHED */),
                        _createElementVNode("line", {
                          stroke: "currentColor",
                          fill: "none",
                          "stroke-width": "2.07",
                          "stroke-miterlimit": "10",
                          x1: "18.56",
                          y1: "10.51",
                          x2: "10.48",
                          y2: "18.59"
                        }, null, -1 /* CACHED */),
                        _createElementVNode("line", {
                          stroke: "currentColor",
                          fill: "none",
                          "stroke-width": "2.07",
                          "stroke-miterlimit": "10",
                          x1: "18.56",
                          y1: "18.59",
                          x2: "10.48",
                          y2: "10.51"
                        }, null, -1 /* CACHED */)
                      ]))])),
                      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-20" }, "Wrong!", -1 /* CACHED */)),
                      _createElementVNode("p", null, "The answer actually is: " + _toDisplayString(_ctx.correctAnswerText) + ".", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_20, "Question " + _toDisplayString(_ctx.questionNumber) + " / " + _toDisplayString(_ctx.totalQuestions), 1 /* TEXT */),
              _createElementVNode("div", {
                innerHTML: _ctx.question.description
              }, null, 8 /* PROPS */, _hoisted_21)
            ]),
            _createElementVNode("img", {
              src: _ctx.showImg(_ctx.question.answerImage),
              alt: "",
              class: "zoom-bg__img"
            }, null, 8 /* PROPS */, _hoisted_22),
            _createElementVNode("div", {
              innerHTML: _ctx.question.answerDescription
            }, null, 8 /* PROPS */, _hoisted_23),
            _createElementVNode("button", {
              class: "button button--cta",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitAnswer && _ctx.submitAnswer(...args)))
            }, "Next Question")
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */)), [
    [_vShow, _ctx.isActive]
  ])
}